<template>
  <v-col
    class="col-sm-6 col-md-4 col-lg-3 col-12"
    v-if="item"
  >
    <v-card elevation="0" @click="routeToReflection" class="roundCard">
      <v-card-subtitle
        :class="`templateType pb-0`"
        :style="{ '--color': template.color || '#888'}"
      >
        {{ $t(`views.reflection.templateTypes.${template.name || 'empty'}`) }}
      </v-card-subtitle>
      <v-card-title class="pt-0 pb-1" style="word-break: break-word">
        {{ item.title }}
      </v-card-title>
      <v-btn
        class="roundCard__button"
        text
        small
        elevation="0"
        @click.exact.stop.prevent="archiveReflection"
      >
        <v-icon
          color="#717073"
          v-if="item.isArchived"
        >
          restore_from_trash
        </v-icon>
        <v-icon
          color="#717073"
          v-if="!item.isArchived"
        >
          delete
        </v-icon>
      </v-btn>
      <v-card-text class="description py-0 mb-0">
        {{ item.description }}
      </v-card-text>
      <v-card-text>
        <div>
          <Avatar
            class="mr-2"
            :user-id="item.createdBy"
            :show-tooltip="true"
          />
          <span class="createdOn">
            {{ createdOn }}
          </span>
        </div>
        <div class="statistics pt-3">
          <v-icon class="material-icons">
            question_answer
          </v-icon>
          {{ item.activityCount || '0' }}

          <v-icon class="pl-1 material-icons">
            person
          </v-icon>
          {{ item.activeUsers.length || '0' }}
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { fromNow } from '@/tools/momentUtils';
import Avatar from '@/shared/components/avatar/Avatar';
import { types } from '../../store/rootTypes';

export default {
  name: 'ReflectionCard',
  components: { Avatar },
  props: {
    item: {
      type: Object,
      required: true,
    },
    backTo: {
      type: [String, Object],
      required: true,
    },
    archived: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      usersProfiles: types.users.getters.usersProfiles,
    }),
    truncatedDescription() {
      if (this.item.description && this.item.description.length > 100) {
        return `${this.item.description.trim().substring(0, 100)}...`;
      }

      return this.item.description;
    },
    template() {
      return this.item.template || {};
    },
    createdOn() {
      return fromNow(this.item.createdOn);
    },
  },
  beforeMount() {
    if (this.item.createdBy) {
      this.getUserProfile(this.item.createdBy);
    }
  },
  methods: {
    ...mapActions({
      getUserProfile: types.users.actions.getUserProfile,
      archive: types.reflections.actions.archiveReflection,
    }),
    routeToReflection() {
      this.$router.push(`/reflections/${this.item.id}?backTo=${this.backTo}`);
    },
    preventRedirection(event) {
      event.preventDefault();
      event.stopPropagation();
    },
    archiveReflection() {
      this.archive({
        reflectionId: this.item.id,
        isArchived: !this.item.isArchived,
      });
    },
  },
};
</script>

<style scoped>
.overlay {
  position: absolute;
  width: 100%;
  top: 0;
  display: flex;
  justify-content: flex-end;
  padding: 2px;
}
.overlayContent {
  border-radius: 4px;
  padding: 6px;
  background-color: #FFFFFF88;
}
.v-card__subtitle.templateType {
  color: var(--color);
  font-size: 9px;
  font-weight: 500;
}

.roundCard {
  position: relative;
  border-radius: 6px;
}

.roundCard__button {
  position: absolute;
  top: 10px;
  right: 10px;
}

.v-card__title {
  font-weight: 600;
  font-size: 16px;
}

.description {
  font-weight: 500;
  font-size: 11px;
  line-height: 17px;
  height: 68px;
  overflow: hidden;
}

.createdOn:first-letter {
  margin-left: 8px;
  text-transform: capitalize;
}

.createdOn {
  display: inline-block;
  font-weight: 500;
  font-size: 11px;
}

.statistics {
  font-size: 12px;
  font-weight: 600;
}

.statistics i {
font-size: 18px;
color: #b3b3b3;
}
</style>
